import { useRef, type ReactNode } from 'react'
import { useRouterState } from '@tanstack/react-router'
import { AlertBanner } from './AlertBanner'
import { Topbar } from './Topbar'
import { useRouteMainFocus } from './use-route-main-focus'

export function AppShellLayout({
  sidebar,
  contextBar,
  children,
}: {
  sidebar: ReactNode
  contextBar?: ReactNode
  children: ReactNode
}) {
  const routeKey = useRouterState({
    select: (state) => `${state.location.pathname}${state.location.searchStr ?? ''}`,
  })
  const mainRef = useRef<HTMLElement>(null)
  useRouteMainFocus(mainRef, routeKey)

  return (
    <div
      data-testid="app-shell-layout"
      className="flex min-h-0 flex-1 flex-col overflow-hidden bg-[var(--color-canvas)]"
    >
      <Topbar />
      <div data-testid="app-shell-body" className="flex min-h-0 flex-1 overflow-hidden">
        {sidebar}
        <div className="flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden">
          {contextBar}
          <AlertBanner />
          <main
            ref={mainRef}
            id="main-content"
            tabIndex={-1}
            data-testid="app-shell-main"
            className="relative flex min-h-0 flex-1 flex-col overflow-auto bg-[var(--color-canvas)] px-[var(--page-padding-x)] pb-8 pt-[var(--page-padding-top)] safe-bottom"
          >
            {children}
          </main>
        </div>
      </div>
    </div>
  )
}
